// APP_CONSTANTS.js
// Reads from window.ENV_CONFIG which is set by public/config/env-config.js
// This allows changing configuration without rebuilding!

const getConfig = () => {
  // Fallback values if ENV_CONFIG is not loaded yet
  const defaults = {
    CENTER_RADIOLOGY_URL: '',
    BACKEND_API: 'https://demo-api.photonpacs.com/api',
    CENTER_HAS_INVALID_PATIENT_IDS: true,
    IDLE_TIMEOUT_ENABLED: false,
    IDLE_TIMEOUT_MINUTES: 300,
    IS_ACR_PACS: true,
    WADO_URI_ROOT: 'https://demo-api.photonpacs.com/dicom/aets/DCM4CHEE/rs',
    CENTER_NAME: 'Photon PACS - MRI',
  };

  return typeof window !== 'undefined' && window.ENV_CONFIG
    ? window.ENV_CONFIG
    : defaults;
};

const config = getConfig();

const CENTER_RADIOLOGY_URL = config.CENTER_RADIOLOGY_URL;
const BACKEND_API = config.BACKEND_API;
const CENTER_HAS_INVALID_PATIENT_IDS = config.CENTER_HAS_INVALID_PATIENT_IDS;
const IDLE_TIMEOUT_ENABLED = false; // config.IDLE_TIMEOUT_ENABLED;
const IDLE_TIMEOUT_MINUTES = 300; //config.IDLE_TIMEOUT_MINUTES;
const IS_ACR_PACS = config.IS_ACR_PACS;
const CENTER_NAME=config.CENTER_NAME;
// Legacy - kept for backward compatibility
const VIEWER_API = 'https://demo-api.photonpacs.com/dicom/aets/DCM4CHEE/rs';

module.exports = {
  VIEWER_API,
  CENTER_RADIOLOGY_URL,
  BACKEND_API,
  CENTER_HAS_INVALID_PATIENT_IDS,
  IDLE_TIMEOUT_ENABLED,
  IDLE_TIMEOUT_MINUTES,
  IS_ACR_PACS,
  CENTER_NAME,
};

